const fontFamilies = {
  default: `Akzidenz, 'Helvetica Neue', Helvetica, Arial, sans-serif`,
  code: `'Source Code Pro', Menlo, monospace`,
};

export default fontFamilies;
